<template>
  <!-- 📱 Mobile Navigation -->
  <div
    class="fixed top-0 left-0 w-full h-full bg-white z-70 flex flex-col items-center overflow-y-auto pt-24 px-4 space-y-4 md:hidden">
    <MobileDropdown :label="$t('common.technology')" @close="$emit('close')" :links="[
      { to: '/technology/documents', label: $t('common.documents') },
      { to: '/technology/luxury_items', label: $t('common.luxury_objects') },
      { to: '/technology/personnel', label: $t('common.critical_personnel') }
    ]" />
    <MobileDropdown :label="$t('common.usecases')" @close="$emit('close')" :links="[
      { to: '/uses/industry', label: $t('common.industry') },
      // { to: '/uses/research', label: $t('common.research') }
    ]" />
    <MobileDropdown :label="$t('common.company')" @close="$emit('close')" :links="[
      { to: '/company/about', label: $t('common.about_us') },
      { to: '/company/careers', label: $t('common.join_us') },
      { to: '/company/contact', label: $t('common.contact') }
    ]" />

    <div class="pt-4 border-t w-full flex justify-center gap-4">
      <LanguageSwitcher />
    </div>
  </div>
</template>

<script lang="ts">
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import DarkModeToggle from '../DarkModeToggle.vue';
import HoverDropdown from './HoverDropdown.vue';
import MobileDropdown from './MobileDropdown.vue';

import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'MobileDropdownMenu',
  components: { LanguageSwitcher, DarkModeToggle, HoverDropdown, MobileDropdown },
  setup() {
    const { t } = useI18n({ useScope: 'global' })

    return {
      t
    };
  }
});
</script>